import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import JobTitleSelector from "pages/JobTitleSelector";
import Apron from "pages/Apron";
import PrintPreview from "pages/PrintPreview";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { ThemeProvider } from "styled-components";
import FormDataProvider from "context/FormDataContext";
import ApiDataProvider from "context/ApiDataContext";
import SignInMessage from "pages/SignInMessage";

function Router() {
  const theme = {
    color: {
      powder_blue: "#ACD7D5",
      dark_electric_blue: "#5A6B7E",
      light_sea_green: "#3EB8AD",
      straw: "#EBE26E",
      middle_blue: "#68C3D4",
    },
  };
  return (
    <ThemeProvider theme={theme}>
      <UnauthenticatedTemplate>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<SignInMessage />} />
          </Routes>
        </BrowserRouter>
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <ApiDataProvider>
          <FormDataProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/apron/:jobTitle" element={<Apron />} />
                <Route path="/print/:jobTitle" element={<PrintPreview />} />
                <Route path="/" element={<JobTitleSelector />} />
              </Routes>
            </BrowserRouter>
          </FormDataProvider>
        </ApiDataProvider>
      </AuthenticatedTemplate>
    </ThemeProvider>
  );
}

export default Router;
